<app-modal
  #discardChangesModal
  [modalMessage]="app.text.app.discardChanges"
  [modalTitle]="app.text.warehouseGroup.modalTitle"
  (ok)="discardChanges()"
  >
</app-modal>

<div class="row mt-2">
  <div class="col-md-12">
    <div>
      <app-paginator
        [length]="app.warehouseGroup.warehouseGroups.length"
        [index]="app.paginator.focus"
        (focus)="app.paginator.focus = $event"
      ></app-paginator>

      <div class="tableFixHead">
        <table class="table table-striped spacing-table">
          <thead>
            <tr>
              @for (column of getWarehouseGroupColumns(); track column) {
                <th>
                  @if (column !== 'actions') {
                    <div class="d-inline-flex">
                      <!-- Sorting and headers -->
                      <div
                    [ngClass]="{
                      'resize-table': app.table.canColumnBeResized(
                        'warehouseGroup.' + column
                      )
                    }"
                        >
                        <span
                      (click)="
                        app.table.toggleSortDirection(
                          'warehouseGroup.' + column
                        );
                        app.table.sort(app.warehouseGroup.warehouseGroups)
                      "
                          >
                          {{
                          app.field.handleSpecialLogicLabels(
                          "warehouseGroup." + column
                          )
                          }}
                        </span>
                      </div>
                      &nbsp;
                      @if ('warehouseGroup.' + column === app.table.sortField) {
                        <span
                          >
                          @if (app.table.sortDirection === 1) {
                            <i
                              class="fa fa-chevron-up"
                            ></i>
                          }
                          @if (app.table.sortDirection === -1) {
                            <i
                              class="fa fa-chevron-down"
                            ></i>
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (column === 'actions') {
                    <span class="pointer">
                      {{ app.text.warehouseGroup.actions }}
                    </span>
                  }
                  <!-- Table filter -->
                  @if (app.filterTable.getFilterTableColumns(column)) {
                    <div>
                      <app-filter-table
                        [column]="column"
                        [columns]="getWarehouseGroupColumns()"
                        [docType]="'warehouseGroup'"
                        [cleanDocs]="app.warehouseGroup.cleanWarehouseDocs"
                        [selectedFilters]="selectedFilters"
                    (resultedDocs)="
                      app.filterTable.getFilterResults($event, 'warehouseGroup')
                    "
                        >
                      </app-filter-table>
                    </div>
                  }
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (
              item of app.paginator.getPage(
              app.warehouseGroup.warehouseGroups
              )
              ; track
              item) {
              <tr
                >
                @for (column of getWarehouseGroupColumns(); track column) {
                  <td class="p-1">
                    <div>
                      @switch (app.table.getColumnTypeDisplay(column)) {
                        @case ('actions') {
                          <div>
                            <!-- Actions -->
                            <span class="actions">
                              @if (app.unlockedId !== item['_id']) {
                                <button
                                  class="btn btn-edit btn-sm"
                                  [title]="app.text.app.edit"
                                  (click)="app.warehouseGroup.edit(item)"
                                  >
                                  <i class="fa fa-edit">&nbsp;&nbsp;</i>
                                  <span>{{ app.text.app.edit }}</span>
                                </button>
                              }
                              @if (app.unlockedId === item['_id']) {
                                <div>
                                  @if (
                                    app.warehouseGroup.modelHasChanges()) {
                                    @if (app.warehouseGroup.modelHasChanges()) {
                                      <button
                                        class="btn btn-sm btn-save"
                                        [title]="app.text.warehouseGroup.save"
                          (click)="
                            app.warehouseGroup.save(
                              app.warehouseGroup.selectedWarehouse
                            )
                          "
                                        >
                                        <i class="fa fa-check"></i> {{ app.text.app.save }}
                                      </button>
                                    }
                                    <button
                                      class="btn btn-sm btn-clean"
                                      (click)="discardChangesModal.open()"
                                      [title]="app.text.warehouseGroup.discard"
                                      >
                                      <i class="fas fa-times"></i>&nbsp;
                                      {{ app.text.post.cancel }}
                                    </button>
                                  } @else {
                                    <button class="btn btn-sm btn-save btn-save-disabled">
                                      <i class="fa fa-check"></i> {{ app.text.app.save }}
                                    </button>
                                    <button
                                      class="btn btn-sm btn-clean"
                          (click)="
                            app.unlockedId = null;
                            app.field.inputSubject.next(true)
                          "
                                      [title]="app.text.warehouseGroup.close"
                                      >
                                      <i class="fas fa-times"></i>&nbsp;
                                      {{ app.text.post.cancel }}
                                    </button>
                                  }
                                </div>
                              }
                              <!-- then block - edit warehouse and there are changes  -->
                              <!-- #else block - edit warehouse and there are no changs  -->
                            </span>
                          </div>
                        }
                        @case ('radio') {
                          <div>
                            <!-- Proactive -->
                            <span>
                              <!-- Read mode -->
                              @if (app.unlockedId !== item['_id']) {
                                <span>
                                  @if (app.field.isTrue(item[column])) {
                                    <i
                                      class="far fa-dot-circle"
                                    ></i>
                                  }
                                  @if (app.field.isFalse(item[column])) {
                                    <i
                                      class="fal fa-circle"
                                    ></i>
                                  }
                                </span>
                              }
                              <!-- Edit mode -->
                              @if (app.unlockedId === item['_id']) {
                                <div>
                                  <div
                                    class="badge cursor-pointer font-style proactive-cell edit-mode-cell"
                                    >
                                    <div
                            [ngClass]="{
                              'selected-option':
                                app.field.isTrue(app.warehouseGroup.selectedWarehouse[column])
                            }"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] = true
                            "
                                      >
                                      Yes
                                    </div>
                                    <div
                            [ngClass]="{
                              'selected-option':
                                app.field.isFalse(app.warehouseGroup.selectedWarehouse[column])
                            }"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] = false
                            "
                                      >
                                      No
                                    </div>
                                  </div>
                                </div>
                              }
                            </span>
                          </div>
                        }
                        @case ('badge') {
                          <div>
                            <!-- Warehouse Impact -->
                            <span>
                              <!-- Read mode -->
                              @if (app.unlockedId !== item['_id']) {
                                <span
                                  class="badge text-center"
                        [ngStyle]="
                          app.field.getColor(
                            'warehouseGroup.' + column,
                            item[column]
                          )
                        "
                                  >
                                  {{
                                  app.field.getOptionText(
                                  "warehouseGroup." + column,
                                  item[column]
                                  )
                                  }}
                                </span>
                              }
                              <!-- Edit mode -->
                              @if (app.unlockedId === item['_id']) {
                                <div
                                  class="custom-select-wrapper"
                                  >
                                  <div
                                    class="badge cursor-pointer"
                          [ngStyle]="
                            app.field.getColor(
                              'warehouseGroup.' + column,
                              app.warehouseGroup.selectedWarehouse[column]
                            )
                          "
                                    (click)="dropdownStatusOpen = !dropdownStatusOpen"
                                    >
                                    {{
                                    app.field.getOptionText(
                                    "warehouseGroup." + column,
                                    app.warehouseGroup.selectedWarehouse[column]
                                    )
                                    }}
                                    <i class="fa-solid fa-caret-down arrow"></i>
                                  </div>
                                  @if (dropdownStatusOpen) {
                                    <div class="custom-dropdown">
                                      @for (
                                        opt of app.field.getOptions(
                                        'warehouseGroup.' + column
                                        )
                                        ; track
                                        opt) {
                                        <div
                                          class="dropdown-option"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] =
                                opt;
                              dropdownStatusOpen = false
                            "
                                          >
                                          {{
                                          app.field.getOptionText(
                                          "warehouseGroup." + column,
                                          opt
                                          )
                                          }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </span>
                          </div>
                        }
                        @case ('time') {
                          <div>
                            <!-- Update time and create time -->
                            {{ item[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                          </div>
                        }
                        <!-- Regular columns -->
                        @case ('normal') {
                          <div>
                            {{ item[column] }}
                          </div>
                        }
                      }
                    </div>
                  </td>
                }
              </tr>
            }
            @if (app.warehouseGroup.warehouseGroups.length === 0) {
              <tr>
                <td colspan="99" class="p-1 text-center">
                  {{ app.text.core.noResults }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
